module.exports = __webpack_public_path__ + "img/icons_31.e21d5a67.svg";